import durianImg from '../image/2.png';
import mangosteenImg from '../image/1.png';

export const CONTACT_EMAIL = 'wqxq_elitestar@163.com';
export const BUSINESS_HOURS = '工作日 9:00 - 18:00';
export const ICP_NUMBER = '蜀ICP备2023008804号';

export const PURCHASE_PROCESS = [
  { step: '1', title: '提交咨询', desc: '填写意向产品、数量与用途，或通过邮件联系我们。' },
  { step: '2', title: '方案报价', desc: '1-2 个工作日内回复报价、起订量与发货周期。' },
  { step: '3', title: '确认订单', desc: '确认款式、数量、包装与收货信息后安排生产/备货。' },
  { step: '4', title: '发货交付', desc: '按约定物流发出，提供物流单号与售后支持。' },
];

export const PURCHASE_FAQ = [
  { q: '最小起订量是多少？', a: '零售咨询无起订量限制；企业批量订购一般 50 件起，具体因产品而异。' },
  { q: '支持定制 logo 吗？', a: '批量订购可提供吊牌、礼盒与 logo 定制方案，请邮件说明需求。' },
  { q: '发货周期多久？', a: '现货 3-5 个工作日；批量定制一般 15-30 个工作日。' },
  { q: '可以开发票吗？', a: '支持开具增值税普通发票，请在下单时注明开票信息。' },
];

export const BRAND_VALUES = [
  {
    icon: 'fa-leaf',
    title: '正念生活',
    desc: '将冥想融入日常，在忙碌中找回呼吸与当下的力量，让身心回归平衡。',
  },
  {
    icon: 'fa-android',
    title: 'AI 陪伴',
    desc: '智能推荐冥想主题与时长，生成个性化练习建议，让入门更简单、坚持更容易。',
  },
  {
    icon: 'fa-paw',
    title: '萌趣陪伴',
    desc: '线上线下联动，水果系列毛绒公仔与 APP 共同营造温暖治愈的冥想仪式感。',
  },
];

export const FEATURES = [
  {
    id: 'love',
    icon: 'fa-heart',
    iconBg: 'bg-pink-500/20',
    iconColor: 'text-pink-400',
    title: '情感疗愈',
    desc: '舒缓情绪压力，学会与感受温柔相处，重建内在安全感。',
    items: ['缓解焦虑情绪', '提升自我接纳', '改善亲密关系心态'],
    detail:
      '通过引导式冥想与呼吸练习，帮助你在情感波动时稳定心神。适合失恋疗愈、关系困扰或情绪低谷时使用，让内心重新获得柔软与力量。',
    meditations: ['主题冥想', '深度冥想'],
    meditationIds: ['theme', 'deep'],
    highlight: false,
    sampleGoals: [
      '希望缓解近期的情感焦虑',
      '想要更平和地面对关系中的不确定',
      '需要建立更好的自我关爱习惯',
    ],
    readingFocus: ['情绪觉察', '身体放松', '自我对话', '日常练习建议'],
    tips: '练习前找一个安静角落，允许任何情绪存在，无需评判自己。',
  },
  {
    id: 'career',
    icon: 'fa-briefcase',
    iconBg: 'bg-blue-500/20',
    iconColor: 'text-blue-400',
    title: '职场减压',
    desc: '释放工作压力，提升专注力，在快节奏中找回清晰与稳定。',
    items: ['班前专注冥想', '午休快速恢复', '睡前释放压力'],
    detail:
      '针对职场场景设计的冥想练习，帮助你在会议前安定心神、在加班后放松身体。通过正念训练提升专注力与情绪韧性，让工作与生活更好平衡。',
    meditations: ['主题冥想', '深度冥想'],
    meditationIds: ['theme', 'deep'],
    highlight: false,
    sampleGoals: [
      '工作压力大，难以放松',
      '希望提升专注与效率',
      '下班回家后仍感到精神紧张',
    ],
    readingFocus: ['压力释放', '专注力训练', '身体扫描', '作息建议'],
    tips: '可搭配 5 分钟呼吸冥想作为工作间隙的「重启按钮」。',
  },
  {
    id: 'calm',
    icon: 'fa-moon-o',
    iconBg: 'bg-green-500/20',
    iconColor: 'text-green-400',
    title: '睡眠放松',
    desc: '睡前静心练习，帮助身心进入休息状态，改善入睡质量。',
    items: ['睡前引导冥想', '身体扫描放松', '呼吸助眠练习'],
    detail:
      '以缓慢呼吸与身体扫描为核心，引导你逐步放下白天的思绪与紧张。适合入睡困难、思绪过多或需要高质量休息的人群。',
    meditations: ['呼吸冥想', '主题冥想'],
    meditationIds: ['breath', 'theme'],
    highlight: false,
    sampleGoals: [
      '躺在床上难以入睡',
      '希望建立睡前放松仪式',
      '夜间容易反复想事情',
    ],
    readingFocus: ['呼吸放缓', '肌肉放松', '思绪安放', '睡眠习惯'],
    tips: '建议调暗灯光、远离屏幕，用冥想替代睡前刷手机。',
  },
  {
    id: 'life',
    icon: 'fa-compass',
    iconBg: 'bg-purple-500/20',
    iconColor: 'text-purple-400',
    title: '深度内观',
    desc: '更长时间的冥想旅程，探索内心、厘清方向，遇见真实的自己。',
    items: ['自我探索练习', '人生方向反思', '长期正念计划'],
    detail:
      '当你希望慢下来、认真倾听内心声音时，深度冥想提供更长、更系统的引导。适合重大决策前的自我梳理，或希望建立长期冥想习惯的用户。',
    meditations: ['主题冥想', '深度冥想'],
    meditationIds: ['theme', 'deep'],
    highlight: true,
    sampleGoals: [
      '面临人生选择，希望内心更清晰',
      '想要开始系统的冥想练习',
      '希望探索更深层的自我认知',
    ],
    readingFocus: ['内在观察', '价值澄清', '长期规划', '练习节奏'],
    tips: '深度练习建议在固定时间进行，每周至少完成一次完整旅程。',
  },
];

export const APP_CAPABILITIES = [
  { title: '引导式冥想', desc: '专业语音引导，零基础也能轻松入门', icon: 'fa-headphones' },
  { title: '呼吸节奏训练', desc: '可视化呼吸动画，帮助调节节奏与放松', icon: 'fa-circle-o-notch' },
  { title: '练习记录追踪', desc: '记录冥想时长与连续打卡，见证成长', icon: 'fa-history' },
  { title: '蓝牙设备联动', desc: '连接智能硬件，拓展沉浸式体验', icon: 'fa-bluetooth' },
];

export const MEDITATION_PROGRAMS = [
  {
    id: 'breath',
    title: '5 分钟呼吸冥想',
    badge: '5 分钟',
    badgeClass: 'bg-primary/30',
    desc: '适合每日快速练习。跟随呼吸节奏，让身心在几分钟内回归平静。',
    scene: '推荐场景：晨间唤醒、工作间隙、睡前放松',
    duration: '约 5 分钟',
    difficulty: '入门',
    sections: [
      { name: '调息准备', meaning: '调整坐姿，关注自然呼吸' },
      { name: '专注呼吸', meaning: '将注意力温和地带回一吸一呼' },
    ],
    tips: '不必追求「空无一物」，念头出现时将注意力轻轻带回呼吸即可。',
    exampleGoals: ['今天需要快速放松', '想要开启正念的一天'],
    relatedFeatureIds: ['calm', 'career'],
    steps: ['选择呼吸冥想课程', '找到舒适姿势坐下', '跟随引导专注呼吸', '结束后感受身体变化'],
  },
  {
    id: 'theme',
    title: '15 分钟主题冥想',
    badge: '15 分钟',
    badgeClass: 'bg-primary/30',
    desc: '围绕情感、职场、睡眠等主题设计，在专注练习中针对性舒缓与恢复。',
    scene: '推荐场景：情感疗愈、职场减压、睡前放松',
    duration: '约 15 分钟',
    difficulty: '进阶',
    sections: [
      { name: '身心放松', meaning: '从头到脚逐步释放紧张' },
      { name: '主题引导', meaning: '围绕所选主题进行正念练习' },
      { name: '回归当下', meaning: '缓慢结束，将平静带入生活' },
    ],
    tips: '选择与你当前状态最相关的主题，效果更好。',
    exampleGoals: ['希望针对工作压力进行放松', '需要情感上的自我关怀'],
    relatedFeatureIds: ['love', 'career', 'life'],
    steps: ['选择冥想主题', '佩戴耳机进入引导', '跟随 15 分钟完整练习', '记录感受与时长'],
  },
  {
    id: 'deep',
    title: '30 分钟深度冥想',
    badge: '30 分钟',
    badgeClass: 'bg-secondary/30',
    desc: '更完整的冥想旅程，适合深度内观与长期练习者，帮助探索内心、稳定情绪。',
    scene: '推荐场景：周末自我时间、人生反思、深度疗愈',
    duration: '约 30 分钟',
    difficulty: '深度',
    sections: [
      { name: '身体扫描', meaning: '觉察并放松全身各部位' },
      { name: '呼吸深化', meaning: '延长呼吸，进入更深放松状态' },
      { name: '内观探索', meaning: '观察念头与感受，不加评判' },
      { name: '整合收束', meaning: '将练习中的平静延续至日常' },
    ],
    tips: '建议预留不被打扰的完整时间，练习前告知家人或同事。',
    exampleGoals: ['希望进行一次完整的自我对话', '想要建立深度冥想习惯'],
    relatedFeatureIds: ['life', 'love', 'career'],
    steps: ['选择安静空间', '开始 30 分钟深度课程', '跟随全程语音引导', '练习后简短记录心得'],
  },
];

/** @deprecated use MEDITATION_PROGRAMS */
export const SPREADS = MEDITATION_PROGRAMS;

export function getMeditation(id) {
  return MEDITATION_PROGRAMS.find((m) => m.id === id);
}

/** @deprecated use getMeditation */
export function getSpread(id) {
  return getMeditation(id);
}

export const GUIDE_STEPS = [
  {
    step: '1',
    title: '下载并登录',
    desc: '在应用商店搜索 Ameowzing，完成账号注册或快捷登录。',
    detail:
      '支持 iOS App Store 与 Android 主流应用商店。首次登录可绑定手机号或第三方账号，便于同步冥想练习记录。',
  },
  {
    step: '2',
    title: '选择冥想主题',
    desc: '根据当前状态选择情感疗愈、职场减压、睡眠放松或深度内观。',
    detail:
      '不必追求「完美状态」，选择此刻最需要的主题即可。即使只有 5 分钟，也是有效的开始。',
  },
  {
    step: '3',
    title: '开始引导练习',
    desc: '点击课程，跟随 AI 语音引导与呼吸动画，进入冥想状态。',
    detail:
      '建议佩戴耳机以获得更好体验。若中途分心，只需温和地将注意力带回引导即可。',
  },
  {
    step: '4',
    title: '记录与坚持',
    desc: '完成练习后自动记录时长，可查看历史与连续打卡，养成冥想习惯。',
    detail:
      '坚持比时长更重要。从每天 5 分钟开始，逐步延长，感受身心变化。',
  },
];

export const TESTIMONIALS = [
  {
    stars: 5,
    quote:
      '「职场减压冥想帮我在会议前快速平静下来，AI 引导语很温柔，像朋友一样陪伴。」',
    author: '— 小林 · 产品经理',
  },
  {
    stars: 5,
    quote:
      '「榴莲公仔摆在冥想角超治愈，每次练习都很有仪式感。朋友也问我在哪买的！」',
    author: '— 阿喵 · 设计师',
  },
  {
    stars: 4.5,
    quote:
      '「睡前 5 分钟呼吸冥想已经成为我的日常，入睡比以前快多了，整个人放松很多。」',
    author: '— 星辰 · 大学生',
  },
];

export const PRODUCTS = [
  {
    slug: 'durian',
    image: durianImg,
    imageAlt: '可爱榴莲水果毛绒公仔效果图',
    badge: '主打款 · 水果系列',
    badgeClass: 'text-yellow-300/90 bg-yellow-500/10',
    title: '可爱榴莲水果毛绒公仔',
    shortDesc: '金黄果肉、翠绿尖刺与甜美笑脸，把「水果之王」化作最治愈的抱抱伙伴。',
    description:
      '把「水果之王」榴莲带回家，化作最治愈的抱抱伙伴。饱满明亮的金黄果肉身躯、一圈翠绿毡布尖刺还原经典榴莲外形，白色圆润笑脸配黑豆眼眸与弯弯笑嘴，柔软棕色四肢憨态可掬，高品质超柔毛绒，适合儿童与水果爱好者。',
    highlights: [
      '超柔亲肤毛绒，拥抱感满满',
      '翠绿毡布尖刺，高度还原榴莲外壳特征',
      '黄、绿、白、棕高对比配色，活泼亮眼辨识度高',
      '甜美笑脸设计，装饰、收藏、送礼皆宜',
    ],
    specs: [
      { label: '材质', value: '优质超柔毛绒 + 毡布尖刺 + 聚酯纤维填充' },
      { label: '尺寸', value: '约 25cm（手工测量略有误差）' },
      { label: '配色', value: '亮黄、翠绿、纯白、棕、黑' },
      { label: '风格', value: '治愈 / 童趣 / 水果系' },
      { label: '用途', value: '陪伴、装饰、礼品' },
      { label: '适用年龄', value: '3 岁及以上' },
    ],
    care: [
      '建议手洗或局部清洁，避免机洗变形',
      '自然晾干，避免暴晒与高温烘干',
      '毡布尖刺部分请勿用力拉扯',
    ],
    priceNote: '零售询价 · 批量 50 件起享优惠',
    moq: '零售 1 件起 / 批发 50 件起',
    packaging: ['标准 OPP 袋', '精美礼盒（可选）', '企业定制包装（批量）'],
    scenarios: ['冥想角落陪伴摆件', '桌面治愈装饰', '节日生日礼物', '企业定制礼品'],
  },
  {
    slug: 'mangosteen',
    image: mangosteenImg,
    imageAlt: '可爱山竹水果毛绒公仔效果图',
    badge: '限定款 · 水果系列',
    badgeClass: 'text-pink-300/90 bg-pink-500/10',
    title: '可爱山竹水果毛绒公仔',
    shortDesc: '饱满紫色外皮与甜美微笑果肉脸，把「水果之后」化作治愈抱抱伙伴。',
    description:
      '把「水果之后」山竹带回家，化作最治愈的抱抱伙伴。饱满紫色外皮、甜美微笑的白色果肉脸，搭配翠绿萼片与柔软棕色四肢，高品质超柔毛绒，适合儿童与水果爱好者。',
    highlights: [
      '超柔亲肤材质，拥抱感满满',
      '独特水果造型，高辨识度萌趣设计',
      '紫、白、绿、棕高对比配色，活泼亮眼',
      '装饰、收藏、送礼皆宜',
    ],
    specs: [
      { label: '材质', value: '优质超柔毛绒 + 聚酯纤维填充' },
      { label: '尺寸', value: '约 22cm（手工测量略有误差）' },
      { label: '配色', value: '紫、白、绿、棕' },
      { label: '风格', value: '治愈 / 童趣 / 水果系' },
      { label: '用途', value: '陪伴、装饰、礼品' },
      { label: '适用年龄', value: '3 岁及以上' },
    ],
    care: [
      '建议手洗或局部清洁，避免机洗变形',
      '自然晾干，避免暴晒与高温烘干',
      '长期放置请避免潮湿环境',
    ],
    priceNote: '零售询价 · 批量 50 件起享优惠',
    moq: '零售 1 件起 / 批发 50 件起',
    packaging: ['标准 OPP 袋', '精美礼盒（可选）', '企业定制包装（批量）'],
    scenarios: ['闺蜜伴手礼', '冥想空间装饰', '品牌活动赠品', '治愈系收藏'],
  },
];

export const FAQ_CATEGORIES = [
  {
    title: '冥想练习',
    items: [
      {
        q: '完全没有冥想经验可以使用吗？',
        a: '可以。Ameowzing 从 5 分钟呼吸冥想开始，配合 AI 语音逐步引导，零基础也能轻松入门。不必追求「放空」，跟随引导即是练习。',
      },
      {
        q: '每天练习多久比较合适？',
        a: '建议从每天 5 分钟开始，逐步增加到 15 或 30 分钟。坚持比单次时长更重要，找到适合自己的节奏即可。',
      },
      {
        q: '练习时总是分心怎么办？',
        a: '分心是正常的。觉察到念头飘走时，温和地将注意力带回呼吸或引导语，这正是冥想训练的核心。',
      },
    ],
  },
  {
    title: 'APP 与设备',
    items: [
      {
        q: '支持哪些手机系统？',
        a: 'APP 支持 iOS 与 Android 主流版本。如遇兼容性问题，请通过技术支持邮箱提交您的设备型号与系统版本，我们将协助排查。',
      },
      {
        q: '蓝牙设备如何配对？',
        a: '请确保手机蓝牙已开启，在 APP 内进入「设备管理」页面，点击「搜索设备」并按提示完成配对。若连接失败，可尝试重启 APP 或参考产品说明书。',
      },
      {
        q: '练习记录会同步到云端吗？',
        a: '登录账号后，冥想历史会自动同步至云端，更换设备登录同一账号即可恢复记录。',
      },
    ],
  },
  {
    title: '周边产品',
    items: [
      {
        q: '毛绒周边如何购买？',
        a: '请前往「购买咨询」页面提交意向，或发送邮件至官方邮箱，注明产品名称与数量，我们将在 1-2 个工作日内回复报价。',
      },
      {
        q: '产品是否支持定制？',
        a: '企业批量订购可提供 logo 定制、礼盒包装等方案，起订量与周期请通过礼品采购页面咨询。',
      },
    ],
  },
  {
    title: '隐私与安全',
    items: [
      {
        q: '如何保护我的隐私数据？',
        a: '我们重视用户隐私。练习记录仅存储于您的账号下，不会向第三方出售或共享个人数据。详细条款请参阅官网隐私政策页面。',
      },
      {
        q: '如何注销账号？',
        a: '在 APP「设置 → 账号与安全 → 注销账号」中提交申请，我们将在 15 个工作日内完成数据删除。注销后数据不可恢复。',
      },
    ],
  },
];

export const SUPPORT_INFO = {
  responseTime: '工作日 1-2 个工作日内回复',
  languages: '中文 / English',
  security: '加密传输 · 隐私保护',
  scope: [
    'APP 闪退、卡顿、登录异常',
    '蓝牙设备配对与连接故障',
    '冥想功能使用问题咨询',
    '账号找回与权限问题',
    '版本更新与兼容性适配',
    '周边产品售后与质量问题',
  ],
  troubleshooting: [
    {
      problem: 'APP 无法登录',
      steps: ['检查网络连接', '确认 APP 为最新版本', '尝试退出后重新登录', '仍失败请邮件联系技术支持'],
    },
    {
      problem: '蓝牙设备连接失败',
      steps: ['确认手机蓝牙已开启', '关闭其他占用蓝牙的应用', '在 APP 设备管理中删除后重新配对', '参考说明书复位设备'],
    },
    {
      problem: '冥想音频无法播放',
      steps: ['检查网络是否稳定', '确认手机音量与静音模式', '退出课程重新进入', '记录问题时间并联系客服'],
    },
  ],
};

export const CONTACT_TYPES = [
  {
    id: 'business',
    icon: 'fa-handshake-o',
    title: '商务合作',
    desc: '渠道代理、品牌联名、企业定制',
    subject: 'Ameowzing 商务合作',
    summary: '欢迎品牌方、渠道商与企业客户洽谈合作，共创冥想 × 萌趣周边新体验。',
    details: [
      '应用商店渠道推广与联合运营',
      '品牌 IP 联名与跨界合作',
      '企业定制礼盒与员工福利方案',
      '线下冥想主题活动与体验合作',
      '媒体采访与内容共创',
    ],
    process: ['提交合作意向', '商务经理对接', '方案评估与报价', '签约执行与复盘'],
  },
  {
    id: 'feedback',
    icon: 'fa-commenting-o',
    title: '产品反馈',
    desc: '功能建议、体验优化、Bug 报告',
    subject: 'Ameowzing 产品反馈',
    summary: '您的每一条反馈，都是 Ameowzing 持续进步的动力。',
    details: [
      'APP 功能体验与界面建议',
      '冥想引导内容与音质优化',
      '新课程与新主题需求',
      'Bug 报告与异常复现步骤',
      '周边产品设计与质量反馈',
    ],
    process: ['描述问题或建议', '产品团队评估', '排期优化或回复说明', '版本更新通知'],
  },
  {
    id: 'gift',
    icon: 'fa-gift',
    title: '礼品采购',
    desc: '批量订购、节日礼盒、周边批发',
    subject: 'Ameowzing 礼品采购',
    summary: '为企业礼品、活动赠品、节日礼盒提供一站式采购咨询。',
    details: [
      '春节、中秋、圣诞等节日礼盒',
      '企业年会与活动伴手礼',
      '冥想主题活动定制周边',
      '零售代理与批发合作',
      'logo 定制与专属包装',
    ],
    process: ['提交采购需求', '获取报价与样品', '确认订单与包装', '生产发货与售后'],
  },
];

export const TIMELINE = [
  { year: '2022', event: 'Ameowzing 项目启动，确立「AI 冥想 + 萌宠陪伴」品牌方向' },
  { year: '2023', event: 'APP 1.0 上线，支持四大冥想主题与基础引导课程' },
  { year: '2024', event: '推出水果系列毛绒周边，打造线上线下冥想仪式感' },
  { year: '2025', event: '新增蓝牙设备联动与 30 分钟深度冥想课程' },
  { year: '2026', event: '持续优化 AI 引导体验，拓展品牌合作与周边产品线' },
];

export function getFeature(id) {
  return FEATURES.find((f) => f.id === id);
}

export function getProduct(slug) {
  return PRODUCTS.find((p) => p.slug === slug);
}

export function getContactType(id) {
  return CONTACT_TYPES.find((c) => c.id === id);
}
